module.exports = __webpack_public_path__ + "img/brushes-mobile_jp.637ac85.jpg";